import { Store } from '@/store/mainStore';

export type NonNullableArray<T extends T[number][]> = Array<NonNullable<T[number]>>;

export default abstract class EngineModule {
	protected readonly store: Store;

	protected constructor(store: Store) {
		this.store = store;
	}

	protected nonNullableArray<T extends Array<any>>(arr: T): NonNullableArray<T> {
		// Schema has always optional return values... use this to return array without nulls and undefined
		return arr.filter((el) => el);
	}
}
